import { useEffect, useState } from 'react';
import { brandLogo } from '@/assets/images';

const navItems = [
  { label: 'INICIO', href: '#inicio' },
  { label: 'FIRMAS', href: '#firmas' },
  { label: 'MUJER', href: '#mujer' },
  { label: 'HOMBRE', href: '#hombre' },
  { label: 'COLECCIONES', href: '#colecciones' },
  { label: 'SOBRE SANO', href: '#sobre' },
  { label: 'RECUERDOS', href: '#recuerdos' },
  { label: 'CONTACTO', href: '#contacto' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-cream-50/95 backdrop-blur-sm border-b border-ink-900/10' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="flex items-center justify-between h-20">
          <a href="#inicio" className="cursor-pointer flex items-center">
            <span
              role="img"
              aria-label="SANO Moda"
              className={`logo-wordmark block w-[88px] h-[22px] md:w-[102px] md:h-[26px] transition-all duration-500 ${scrolled ? 'logo-black' : 'logo-white'}`}
            />
          </a>

          <nav className="hidden lg:flex items-center gap-4 xl:gap-7">
            {navItems.map((it) => (
              <a
                key={it.label}
                href={it.href}
                className="text-[11px] tracking-widest text-ink-800 hover:text-ink-500 transition-colors cursor-pointer"
              >
                {it.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-4 md:gap-5">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Calle+San+Vicente+Ferrer+34+Lliria+Valencia"
              target="_blank"
              rel="noreferrer"
              className={`w-8 h-8 flex items-center justify-center transition-colors cursor-pointer ${scrolled ? 'text-ink-800 hover:text-ink-500' : 'text-cream-50 hover:text-cream-200'}`}
              aria-label="Cómo llegar a SANO Moda, Calle San Vicente Ferrer 34, Llíria"
              title="Cómo llegar · SANO Moda, Llíria"
            >
              <i className="ri-map-pin-line text-lg"></i>
            </a>
            <a
              href="https://instagram.com/ropasano"
              target="_blank"
              rel="noreferrer"
              className={`w-8 h-8 flex items-center justify-center transition-colors cursor-pointer ${scrolled ? 'text-ink-800 hover:text-ink-500' : 'text-cream-50 hover:text-cream-200'}`}
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://www.facebook.com/share/1JXngLyhbp/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              className={`w-8 h-8 flex items-center justify-center transition-colors cursor-pointer ${scrolled ? 'text-ink-800 hover:text-ink-500' : 'text-cream-50 hover:text-cream-200'}`}
              aria-label="Facebook"
            >
              <i className="ri-facebook-circle-line text-lg"></i>
            </a>
            <button
              onClick={() => setMenuOpen(true)}
              className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-ink-800' : 'text-cream-50'}`}
              aria-label="Menú"
            >
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 z-50 bg-cream-50 lg:hidden">
          <div className="flex items-center justify-between h-20 px-6">
            <img
              src={brandLogo}
              alt="SANO Moda"
              title="SANO Moda · Llíria, Valencia"
              className="h-6 w-auto brightness-0"
            />
            <button onClick={() => setMenuOpen(false)} className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
          <nav className="flex flex-col items-center gap-7 mt-14">
            {navItems.map((it) => (
              <a
                key={it.label}
                href={it.href}
                onClick={() => setMenuOpen(false)}
                className="text-sm tracking-widest text-ink-900 cursor-pointer"
              >
                {it.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}